import { SearchState } from '../../../models';
import { SEARCH_MUTATIONS_KEYS } from '../search.const';
import { SearchMutation } from '../search.interfaces';

export class IncreasePageMutation implements SearchMutation {

  mutations = {
    [SEARCH_MUTATIONS_KEYS.increasePage]: (localState: SearchState) => {
      localState.page++;
    }
  };
}
